module.exports = __webpack_public_path__ + "static/media/td.08f799db.gif";